import moment from 'moment'
import {Nullable} from '../../../app/TypeHelpers'
import {PAYMENT_TYPE} from '../../../CodeMaster'
import {durationString} from '../helpers/helpers'
import {PaymentItemForViewFacility} from './PaymentItemForViewFacility'

export class PaymentItemForViewDuration extends PaymentItemForViewFacility {

    private readonly startMoment: moment.Moment
    private readonly endMoment: moment.Moment

    constructor(
        paymentType: PAYMENT_TYPE,
        charge: Nullable<number>,
        startMoment: moment.Moment,
        endMoment: moment.Moment,
    ) {
        super(paymentType, charge)
        this.startMoment = startMoment
        this.endMoment = endMoment
    }

    quantityWithUnit(): string {
        return durationString(this.startMoment, this.endMoment)
    }
}
